import {
    Component,
    Inject,
    OnInit,
    Output,
    ViewEncapsulation,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CodigoDTO } from "app/main/apps/shared/interfaces/codigo.interface";
import { RegionComunaDTO } from "app/main/apps/shared/interfaces/region-comuna.interface";
import { MatSelectChange } from "@angular/material/select";
import { CodigosService } from "app/main/apps/shared/services/rest/codigos.service";
import { ContratistaService } from "app/main/apps/shared/services/rest/contratista.service";
import { NotificacionesService } from "app/main/apps/shared/services/rest/notificaciones.service";
import { Subscription } from "rxjs";
import { OnDestroy } from "@angular/core";

@Component({
    selector: "app-dialog-zonas-cobertura",
    templateUrl: "./dialog-zonas-cobertura.component.html",
    styleUrls: ["./dialog-zonas-cobertura.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogZonasCoberturaComponent implements OnInit, OnDestroy {
    comunas = new FormControl();
    listaComunas: CodigoDTO[] = [];
    private subscripciones: Subscription;
    constructor(
        public dialogRef: MatDialogRef<DialogZonasCoberturaComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            regiones: RegionComunaDTO;
            rutContratista: number;
            comunasContratrista: CodigoDTO[];
        },
        private _codigosSrvc: CodigosService,
        private _contratistaSrvc: ContratistaService,
        private _notificacionSrvc: NotificacionesService
    ) {
        this.subscripciones = new Subscription();
    }

    ngOnInit(): void {
        this.subscripciones.add(
            this._contratistaSrvc.contratistaChanged$.subscribe(
                (contratista) =>
                    (this.data.comunasContratrista = contratista.comunas)
            )
        );
    }

    buscarComunasRegion(event: MatSelectChange) {
        //console.log(event.value);

        this.subscripciones.add(
            this._codigosSrvc
                .fetchComunasRegion(event.value)
                .subscribe((comunas:RegionComunaDTO[]) => {

                    //Filtro las comunas que ya fueron agregadas
                    for(var i=0; i < comunas.length;i++){
                        this.data.comunasContratrista.forEach(a => {
                          if (a.id == comunas[i]?.id){
                            comunas.splice(i,1);
                            i--;
                          }
                        })
                    }

                    this.listaComunas = comunas
                
                }
        ))
    }

    guardar() {
        //console.log(this.data.comunasContratrista);

        //console.log(this.comunas.value);
        const comunasNuevas = this.comunas.value.map((comuna) => comuna.id);
        const comunasAntiguas = this.data.comunasContratrista.map(
            (comuna) => comuna.id
        );
        //console.log(comunasAntiguas);
        //console.log(comunasNuevas);
        let comunasConcat = comunasAntiguas.concat(comunasNuevas);
        comunasConcat = [...new Set([...comunasAntiguas, ...comunasNuevas])];

        this.subscripciones.add(
            this._contratistaSrvc
                .actualizaComunas(this.data.rutContratista, comunasConcat)
                .subscribe((resp) => {
                    this._notificacionSrvc.mostrarNotificacion(
                        "Zonas de cobertura actualizadas",
                        "success"
                    );
                    this.dialogRef.close();
                    this._contratistaSrvc.contratistasRefresh$.next(true);
                })
        );
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
